import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts'
import { getStackedBarOptions } from '../../utils/helperFunctions'
import { BarChartsDataType, CountChartDataType } from '@app-store'
import {
  BAR_HEIGHT,
  CHART_PADDING,
  DASHBOARD,
  ENTITY_NAME,
  MIN_CHART_HEIGHT,
} from '../../utils/constants'
import { LegendItem } from './LegendItem'
import { DASHBOARD_CHART_COLOR } from '@ui-kit'

const CountChart = ({
  assigned,
  unassigned,
  handleBarClick,
  selectedTab,
  setActivePoint,
  activePoint,
  highlightedStatus,
}: CountChartDataType) => {
  const calculatedHeight = Math.max(
    MIN_CHART_HEIGHT,
    assigned?.categories.length * BAR_HEIGHT + CHART_PADDING
  )
  const assignedOptions = getStackedBarOptions({
    height: calculatedHeight,
    categories: assigned?.categories,
    series: assigned?.series,
    legendEnabled: true,
    onBarClick: (data) => {
      setActivePoint((prev) => {
        const isSame =
          prev?.category === data.category && prev?.status === data.status
        handleBarClick(
          isSame
            ? {
                userId: data.userId,
                category: null,
                status: data.status,
                count: data.count,
              }
            : data
        )

        return isSame
          ? null
          : {
              category: data.category,
              status: data.status,
            }
      })
    },
    activePoint: activePoint,
    highlightedStatus: highlightedStatus,
  })

  const unassignedOptions = getStackedBarOptions({
    height: 55,
    categories: unassigned?.categories,
    series: unassigned?.series,
    legendEnabled: false,
    xAxisLabelsEnabled: true,
    pointWidth: 15,
    onBarClick: (data) => {
      setActivePoint((prev) => {
        const isSame =
          prev?.category === data.category && prev?.status === data.status
        handleBarClick(
          isSame
            ? {
                userId: data.userId,
                category: null,
                status: data.status,
                count: data.count,
              }
            : data
        )

        return isSame
          ? null
          : {
              category: data.category,
              status: data.status,
            }
      })
    },
    activePoint: activePoint,
    highlightedStatus: highlightedStatus,
  })
  const getMessage = () => {
    if (selectedTab === DASHBOARD.INTAKE || selectedTab === ENTITY_NAME.CASE) {
      return DASHBOARD.COUNT_APPLICATION
    } else if (selectedTab === DASHBOARD.DOCUMENT) {
      return DASHBOARD.COUNT_OF_DOCUMENT
    } else {
      return ''
    }
  }

  return (
    <div className="flex gap-4 w-full h-[21.2rem]">
      <div className="w-full">
        <BarCharts
          unassigned={{
            unassignedOptions: unassignedOptions,
            unassignedRef: unassigned.ref,
          }}
          assigned={{
            assignedOptions: assignedOptions,
            assignedRef: assigned.ref,
          }}
          message={getMessage()}
          selectedTab={selectedTab}
        />
      </div>
    </div>
  )
}

const BarCharts = ({
  unassigned,
  assigned,
  message,
  selectedTab,
}: BarChartsDataType) => {
  return (
    <div className="flex flex-col items-center w-full">
      <div className="w-full">
        <span className="flex mb-1 font-semibold text-base">{message}</span>
        <div className="h-[3.7rem]">
          <HighchartsReact
            highcharts={Highcharts}
            options={unassigned.unassignedOptions}
            ref={unassigned.unassignedRef}
          />
        </div>
      </div>

      <div className="w-full">
        <div className="h-[13.65rem] overflow-auto">
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              ...assigned.assignedOptions,
              legend: { enabled: false },
            }}
            ref={assigned.assignedRef}
          />
        </div>
        <div className="sticky top-0 z-10 bg-white py-1 flex justify-center gap-6">
          <LegendItem
            color={DASHBOARD_CHART_COLOR.OVERDUE_COLOR}
            label={DASHBOARD.OVERDUE}
          />
          <LegendItem
            color={DASHBOARD_CHART_COLOR.AT_RISK_COLOR}
            label={DASHBOARD.AT_RISK}
          />
          <LegendItem
            color={DASHBOARD_CHART_COLOR.ON_TRACK_COLOR}
            label={DASHBOARD.ON_TRACK}
          />
          {selectedTab === ENTITY_NAME.CASE && (
            <LegendItem
              color={DASHBOARD_CHART_COLOR.PAUSED_MI_COLOR}
              label={DASHBOARD.PAUSED_MI}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default CountChart
